import { type FC, type ReactNode } from 'react';
import classnames from 'classnames';
import { Link } from 'dibs-elements/exports/Link';

import styles from './NftSearchBarTerm.scss';

type Props = {
    title: string;
    term: string;
    subterm: string | ReactNode;
    image: ReactNode;
    defaultAvatar?: string;
    href: string;
    handleRowClick: (arg0: string, arg1: string) => void;
    cursorHighlightId?: string;
    id: string;
};

export const NftSearchBarTerm: FC<Props> = ({
    title,
    term,
    subterm,
    image,
    defaultAvatar,
    href,
    handleRowClick,
    cursorHighlightId,
    id,
}) => {
    const searchBarTermClasses = classnames(styles.item, {
        [styles.active]: id === cursorHighlightId,
    });

    return (
        <div className={searchBarTermClasses}>
            <Link
                dataTn="search-bar-term"
                className={styles.link}
                href={href}
                onClick={e => {
                    e.preventDefault();
                    handleRowClick(term, href);
                }}
            >
                <div className={styles.container}>
                    {title === 'CREATORS' ? (
                        <div
                            className={styles.avatarContainer}
                            style={{ background: defaultAvatar }}
                        >
                            {image}
                        </div>
                    ) : (
                        image && <div className={styles.imageContainer}>{image}</div>
                    )}
                    <div className={styles.terms}>
                        <p className={styles.term}>{term}</p>
                        <p className={styles.subterm}>{subterm}</p>
                    </div>
                </div>
            </Link>
        </div>
    );
};
